<script setup lang="ts">
defineProps<{
  title: string;
  ink?: boolean;
  alert?: boolean;
}>();
</script>

<template>
  <div class="flex w-full flex-col gap-[6px]">
    <h1
      class="text-encre text-[24px] leading-[1.15] font-bold tracking-[-0.2px]"
    >
      {{ title }}
    </h1>
    <p
      v-if="$slots.default"
      class="text-[14px] leading-[1.4] break-words"
      :class="ink ? 'text-encre' : 'text-encre-douce'"
      :role="alert ? 'alert' : undefined"
    >
      <slot />
    </p>
  </div>
</template>
